import { AppContext } from "contexts/AppContext";
import useBundles from "hooks/useBundles";
import React, { useContext, useEffect, useMemo, useState } from "react";
import useExtraServices from "hooks/useExtraServices";
import Bundles from "components/Bundles";

const ExtraServicesList = () => {
  const [state] = useContext(AppContext);

  const {
    bundles,
    fetchingBundles,
    step4Bundles,
    extraServices,
    fetchingExtraServices,
    step4ExtraServices,
  } = state;

  const { onSelectExtraService, onDeselectOptionalExtraServices } =
    useExtraServices();

  const { onSelectBundle } = useBundles();

  const [openedBundle, setOpenedBundle] = useState();

  const alternativesInBundleItems = useMemo(() => {
    if (fetchingBundles) {
      return [];
    }

    const allBundles = bundles
      .map((b) => b.bundles)
      .flat()
      .filter((b) => step4Bundles.includes(b.id));

    return allBundles
      .map((b) => b.packageItems.map((p) => p.alternativeLabel))
      .flat();
  }, [fetchingBundles, bundles, step4Bundles]);

  useEffect(() => {
    if (
      fetchingBundles ||
      fetchingExtraServices ||
      step4ExtraServices.length === 0
    ) {
      return;
    }

    step4ExtraServices.forEach((serviceId) => {
      const service = extraServices.find((el) =>
        el.extraservices.some((s) => s.value === serviceId)
      );

      const alternativeIsInSelectedBundle = alternativesInBundleItems.includes(
        service.alternative
      );

      // Controllo che sia selezionato perché onSelectExtraService
      // se chiamato con un id non presente lo aggiunge
      // per quello non itero su tutti gli extraservices di service
      const isServiceSelected = step4ExtraServices.some((el) =>
        service.extraservices.some((s) => s.value === el)
      );

      if (isServiceSelected && alternativeIsInSelectedBundle) {
        onSelectExtraService(serviceId);
      }
    });
  }, [
    alternativesInBundleItems,
    extraServices,
    step4ExtraServices,
    fetchingBundles,
    fetchingExtraServices,
    onSelectExtraService,
  ]);

  return (
    <Bundles
      bundles={bundles}
      selectedBundles={step4Bundles}
      fetchingBundles={fetchingBundles}
      onSelectBundle={onSelectBundle}
      openedBundle={openedBundle}
      onOpenBundle={(bundleId) => setOpenedBundle(bundleId)}
      fetchingExtraServices={fetchingExtraServices}
      extraServices={extraServices}
      selectedExtraServices={step4ExtraServices}
      onSelectExtraService={onSelectExtraService}
      onDeselectOptionalExtraServices={onDeselectOptionalExtraServices}
    />
  );
};

export default ExtraServicesList;
